import { render, staticRenderFns } from "./TempoProcesPreparoMensal.vue?vue&type=template&id=f239d55e&"
import script from "./TempoProcesPreparoMensal.vue?vue&type=script&lang=js&"
export * from "./TempoProcesPreparoMensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports